import React from 'react';
import Icon from '../atoms/Icon';

function BadgeIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 30 32">
      <g
        fill='#FDD023'
        stroke='#070A13'
        stroke-width='2.33333'
        stroke-miterlimit='10'
      >
        <path d='M14.859 1.62329L18.3193 4.97162L23.0875 4.29729L23.9193 9.03979L28.173 11.2973L26.059 15.6233L28.173 19.9493L23.9193 22.2068L23.0875 26.9493L18.3193 26.275L14.859 29.6233L11.3975 26.275L6.62932 26.9493L5.79749 22.2068L1.54382 19.9493L3.65899 15.6233L1.54382 11.2973L5.79749 9.03979L6.62932 4.29729L11.3975 4.97162L14.859 1.62329Z'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(BadgeIcon);
